import RegionalLayout from "./RegionalLayout";
import { ClipboardCheck } from "lucide-react";

const crd = {
  background: "var(--surface-card)",
  border: "var(--border-width, 1px) solid var(--border-default)",
  borderRadius: "1rem",
  boxShadow: "var(--shadow-card)",
};
const tp = { color: "var(--text-primary)" };
const ts = { color: "var(--text-secondary)" };

export default function ManagerValidation() {
  return (
    <RegionalLayout>
      <div className="max-w-[1440px] mx-auto space-y-5">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={tp}>Manager Validation</h1>
          <p className="text-sm mt-0.5" style={ts}>MVF completion rates, rating distribution, and alignment analysis</p>
        </div>
        <div className="p-12 flex flex-col items-center text-center" style={crd} data-testid="validation-coming-soon">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(168,85,247,0.08)" }}>
            <ClipboardCheck className="w-8 h-8" style={{ color: "#a855f7" }} />
          </div>
          <p className="text-lg font-semibold" style={tp}>Coming Soon</p>
          <p className="text-sm mt-2 max-w-md" style={ts}>
            Completion rate per manager, aggregate ratings across five dimensions,
            and team-level alignment between self-assessment and manager validation scores.
          </p>
        </div>
      </div>
    </RegionalLayout>
  );
}
